/**
 * Empty-room / founding-member mode — honest scarcity, not fake abundance.
 */

/** Maximus — founder welcome profile (not a fake local match). */
export const MAXIMUS_USER_ID = 'usr_6dafa6e52eb24e83bc9d2ecf1882227a'
export const MAXIMUS_INVITE_CODE = 'maximus'

/** First N completed onboardings get founding status permanently. */
export const FOUNDING_MEMBER_CAP = 500

/** Free cold intros granted to founding members (lifetime pool). */
export const FOUNDING_COLD_INTROS = 3

/** When searchable verified members (excl. Maximus + bots) are below this, empty-room UI is on. */
export const EMPTY_ROOM_MEMBER_THRESHOLD = 40

export const FOUNDING_BADGE_LABEL = 'Founding member'
export const WELCOME_THREAD_INTRO =
  "Hey — I'm Maximus. I built PairVelle with Manticore. You're early, and that's the point. Finish your profile, invite people worth meeting, and I'll help you get oriented. This is a welcome thread, not a fake match."
